module.exports = __webpack_public_path__ + "static/factors-affecting-price-shipping-loading-82949d813ae91543ed620ef997f984b0.png";